import React from 'react';
import { Link } from 'react-router-dom';
import { playbooks } from '../../data/playbookTaxonomy';
import { BookOpenIcon } from '@heroicons/react/24/outline';

const PlaybooksIndex = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-white mb-8">Playbooks</h1>
          
          <div className="space-y-6">
            {playbooks.map((playbook) => (
              <div
                key={playbook.id}
                className="bg-gray-900 rounded-lg border border-gray-800 overflow-hidden hover:border-gray-700 transition-colors"
              >
                <Link
                  to={`/playbooks/${playbook.id}/${playbook.sections[0].id}`}
                  className="block p-6"
                >
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <BookOpenIcon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="ml-4">
                      <h2 className="text-xl font-semibold text-white mb-2">
                        {playbook.title}
                      </h2>
                      <p className="text-gray-400 mb-4">
                        {playbook.description}
                      </p>
                      <div className="flex items-center text-sm text-gray-500">
                        <span>{playbook.sections.length} sections</span>
                        <span className="mx-2">•</span>
                        <span>Start with {playbook.sections[0].title}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaybooksIndex; 